import { DataItem } from '../../../../../@types/DataItem';
import type { GerenciadorPrecos } from '../../../../../@types/GerenciadorPrecos';
import type { ResponsibleFilterOption } from '../../../../Administrador/Produtos/Components/SetupIpaPricingResponsibilities/service';
import { SegmentoValue } from '../../../../../reducers/gerenciadorPrecos/filters/filtersValues';
import { MoreFiltersValue } from '../../../../../reducers/gerenciadorPrecos/filters/moreFilters';

export type SavedResponsible = GerenciadorPrecos.SavedResponsible;

type ResponsibleOption = ResponsibleFilterOption;

const savedSegmentTypes = {
  sensibilities: 'infoPriceSensibility',
  exclusive: 'sensibilityType',
  curveAbcLocal: 'infoPriceAbcClass',
  curveAbcGlobal: 'infoPriceGlobalAbcClass',
  curve: 'abcClass',
} as const;

export const getSavedSegmentValues = (key: string, values: unknown): SegmentoValue[] => {
  const type = savedSegmentTypes[key as keyof typeof savedSegmentTypes];

  if (!type || !Array.isArray(values)) return [];

  return values.map(value => ({
    type,
    value: String(value),
  }));
};

export const getSavedMoreFilterCache = (key: MoreFiltersValue, values: unknown): DataItem[] => {
  if (!Array.isArray(values) || (key !== 'scope' && key !== 'ruleIds' && key !== 'architectureIds')) return [];

  return values.map(value => ({ label: String(value), value: String(value) }));
};

export const toSavedResponsibleValues = (values: string[] = [], options: ResponsibleOption[] = []): SavedResponsible[] => {
  return values.slice(0, 1).map(id => {
    const option = options.find(item => item.value === id);

    const savedResponsible: SavedResponsible = {
      id,
      name: option?.name ?? option?.label ?? '',
      email: option?.email ?? '',
    };

    return savedResponsible;
  });
};

export const getSavedResponsibleFilter = (values: unknown): { value: string[]; cache: ResponsibleOption[] } => {
  if (!Array.isArray(values)) return { value: [], cache: [] };

  const responsibles = values
    .map(value => {
      if (typeof value === 'string') {
        return { id: value, name: value, email: '' };
      }

      if (!value || typeof value !== 'object') return null;

      const responsible = value as Partial<SavedResponsible>;
      if (typeof responsible.id !== 'string') return null;

      return {
        id: responsible.id,
        name: typeof responsible.name === 'string' ? responsible.name : '',
        email: typeof responsible.email === 'string' ? responsible.email : '',
      };
    })
    .filter((value): value is SavedResponsible => value !== null)
    .slice(0, 1);

  return {
    value: responsibles.map(({ id }) => id),
    cache: responsibles.map(({ id, name, email }) => ({
      label: name,
      value: id,
      name,
      email,
    })),
  };
};
